// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".format.svelte-s7s18v{cursor:help}.tooltip{color:var(--color-base2) !important}", ""]);
// Exports
module.exports = exports;
